import React, { useEffect, useState } from "react";
import { authService } from "../services";

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function MasterLocation() {
  const [locationList, setLocationList] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const formData = location.state || {};

  useEffect(() => {
    GetAllLocationsAPI();
  }, []);

  // Fetch Location List
  const GetAllLocationsAPI = async () => {
    try {
      const payload = {
        userId: "string",
        pageNumber: 1,
        pageSize: 100,
      };
      const res = await authService.GetAllLocationsAPI(payload);
      if (res && res.data) {
        // const filteredLocations = res.data.locationList.filter(
        //   (loc) => loc.locationName?.trim()
        // );
        // setLocationList(filteredLocations);
        const filteredLocations = res.data.locationList
          .filter((loc) => loc.locationName?.trim())
          .sort((a, b) => a.locationName.localeCompare(b.locationName)); // Sort alphabetically
        setLocationList(filteredLocations);
      }
    } catch (error) {
      console.log("Error fetching location list");
    }
  };

  // Handle Location Click
  const toggleLocation = (id) => {
    setSelectedLocations((prev) =>
      prev.includes(id) ? prev.filter((loc) => loc !== id) : [...prev, id]
    );
  };

  // Handle Next button click
  const handleNext = () => {
    console.log("Selected Locations:", selectedLocations);
    const updatedFormData = {
      ...formData,
      locationPrefrences:
        selectedLocations.length > 0 ? selectedLocations : [0],
    };
    console.log("Updated Form Data  Loaction:", updatedFormData);
    navigate("/rewards", { state: updatedFormData });
  };

  return (
    <div className="landing-container mobile-css2">
      <div className="container">
        <div className="logo-container mobile-css">
          <img src="/images/mainLogo.png" alt="Logo" className="mian-logo" />
        </div>

        <div className="master-location">
          <div className="text-center text-white">
            <h2>Help us personalise your experience</h2>
          </div>

          {/* Locations Section */}
          <div className="master-locatioainer2">
            <h4 className="text-white">Favourite Locations</h4>
            <p className="text-white">
              Which restaurants you would like to receive news and offers from?
            </p>
            <h6 className="text-white">Select all that apply</h6>

            <div className="master-button2">
              {locationList.map((location) => (
                <div key={location.id} className="master-button">
                  <button
                    // className="btn"
                    className={`btn ${
                      selectedLocations.includes(location.id) ? "selected" : ""
                    }`}
                    onClick={() => toggleLocation(location.id)}
                  >
                    {location.locationName}
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Next Button */}
          <div className="text-center">
            <button className="sign-up-button check2" onClick={handleNext}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MasterLocation;
